import React from 'react';
import ReactDOM from 'react-dom';
// Must run before the router reads the address.
import 'helpers/autoLoginToken';
import { Provider } from 'react-redux';
import { rootEpic, rootReducer } from 'reducers/rootReducer';
import { composeWithDevTools } from 'redux-devtools-extension';
import { applyMiddleware, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import App from './App';
import './styles/Main.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { StripeProvider } from 'react-stripe-elements';
import { STRIPE_KEY } from 'appConstants';

const epicMiddleware = createEpicMiddleware();

const configureStore = () => {
  const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(epicMiddleware))
  );
  epicMiddleware.run(rootEpic);
  return store;
};

export const store = configureStore();

ReactDOM.render(
  <StripeProvider apiKey={STRIPE_KEY}>
    <Provider store={store}>
      <App />
    </Provider>
  </StripeProvider>,
  document.getElementById('root')
);
